<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">point_of_sale</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Últimas vendas</h2>
    <span class="modal-subtitle">{{ data.nomePessoa }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" (click)="fechar()"
      matTooltip="Fechar" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content ultimas-vendas-conteudo">
  <mat-tab-group appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true"
    (selectedIndexChange)="abrirAba($event)">

    <!-- ================= Notas fiscais ================= -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">receipt_long</mat-icon>
        <span class="tab-label-text">Notas fiscais</span>
      </ng-template>

      <div class="ultimas-vendas-aba">
        @if (!possuiPermissaoNotas) {
          <app-empty-state icon="lock" title="Sem permissão para visualizar notas fiscais"
            subtitle="Solicite ao administrador a permissão Visualizar da NF-e.">
          </app-empty-state>
        } @else if (isCarregando.notas) {
          <app-loading-box-default-list></app-loading-box-default-list>
        } @else if (notas.length === 0) {
          <app-empty-state icon="receipt_long" title="Nenhuma nota fiscal"
            subtitle="Este cliente ainda não tem notas fiscais emitidas.">
          </app-empty-state>
        } @else {
          <div class="desktop-view">
            <div class="table-container">
              <table mat-table [dataSource]="notasExibidas" matSort [matSortActive]="ordenacao.notas.coluna"
                [matSortDirection]="ordenacao.notas.direcao"
                (matSortChange)="atualizarOrdenacao('notas', $event)" class="w-100">
                <ng-container matColumnDef="numero">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Número</th>
                  <td mat-cell *matCellDef="let nota">
                    <ng-container *ngTemplateOutlet="tplNumeroNota; context: { $implicit: nota }"></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="data">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Data</th>
                  <td mat-cell *matCellDef="let nota">{{ nota.data | date:'dd/MM/yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Total</th>
                  <td mat-cell *matCellDef="let nota" class="text-end">{{ nota.total | abnt:'preco':2 }}</td>
                </ng-container>

                <ng-container matColumnDef="situacao">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
                  <td mat-cell *matCellDef="let nota">
                    <span [class]="'status-badge ' + classeBadgeNota(nota)">
                      <mat-icon class="material-symbols-outlined">{{ iconeNota(nota) }}</mat-icon>
                      {{ nota.situacao }}
                    </span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="colunasNotas"></tr>
                <tr mat-row *matRowDef="let row; columns: colunasNotas"></tr>
              </table>
            </div>
          </div>

          <div class="mobile-view">
            @for (nota of notasExibidas; track nota.idNFeSaida) {
              <div class="card-mobile mb-3">
                <div class="card-header-mobile d-flex justify-content-between align-items-center gap-2">
                  <ng-container *ngTemplateOutlet="tplNumeroNota; context: { $implicit: nota }"></ng-container>
                </div>
                <div class="card-body-mobile p-3">
                  <div class="mb-2"><strong>Data:</strong> {{ nota.data | date:'dd/MM/yyyy' }}</div>
                  <div class="mb-2"><strong>Total:</strong> {{ nota.total | abnt:'preco':2 }}</div>
                  <div>
                    <strong>Situação:</strong>
                    <span [class]="'status-badge ms-1 ' + classeBadgeNota(nota)">
                      <mat-icon class="material-symbols-outlined">{{ iconeNota(nota) }}</mat-icon>
                      {{ nota.situacao }}
                    </span>
                  </div>
                </div>
              </div>
            }
          </div>

          @if (notas.length === 10) {
            <small class="d-block text-muted mt-2">São exibidos apenas os 10 últimos registros.</small>
          }
        }
      </div>
    </mat-tab>

    <!-- ================= Vendas ================= -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">shopping_cart</mat-icon>
        <span class="tab-label-text">Vendas</span>
      </ng-template>

      <div class="ultimas-vendas-aba">
        @if (!possuiPermissaoVendas) {
          <app-empty-state icon="lock" title="Sem permissão para visualizar Processo de Venda"
            subtitle="Solicite ao administrador a permissão Visualizar do Processo de Venda.">
          </app-empty-state>
        } @else if (isCarregando.vendas) {
          <app-loading-box-default-list></app-loading-box-default-list>
        } @else if (vendas.length === 0) {
          <app-empty-state icon="shopping_cart" title="Nenhuma venda"
            subtitle="Este cliente ainda não tem pedidos de venda.">
          </app-empty-state>
        } @else {
          <div class="desktop-view">
            <div class="table-container">
              <table mat-table [dataSource]="vendasExibidas" matSort [matSortActive]="ordenacao.vendas.coluna"
                [matSortDirection]="ordenacao.vendas.direcao"
                (matSortChange)="atualizarOrdenacao('vendas', $event)" class="w-100">
                <ng-container matColumnDef="numero">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Número</th>
                  <td mat-cell *matCellDef="let venda">
                    <ng-container *ngTemplateOutlet="tplNumeroVenda; context: { $implicit: venda }"></ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="data">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Data</th>
                  <td mat-cell *matCellDef="let venda">{{ venda.data | date:'dd/MM/yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="total">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Total</th>
                  <td mat-cell *matCellDef="let venda" class="text-end">{{ venda.total | abnt:'preco':2 }}</td>
                </ng-container>

                <ng-container matColumnDef="situacao">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>Situação</th>
                  <td mat-cell *matCellDef="let venda">
                    @let cor = corDaEtapa(venda);
                    <span class="status-badge" [style.background]="cor.fundo" [style.color]="cor.conteudo">{{ venda.situacao }}</span>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="colunasVendas"></tr>
                <tr mat-row *matRowDef="let row; columns: colunasVendas"></tr>
              </table>
            </div>
          </div>

          <div class="mobile-view">
            @for (venda of vendasExibidas; track venda.idVenda) {
              <div class="card-mobile mb-3">
                <div class="card-header-mobile d-flex justify-content-between align-items-center gap-2">
                  <ng-container *ngTemplateOutlet="tplNumeroVenda; context: { $implicit: venda }"></ng-container>
                </div>
                <div class="card-body-mobile p-3">
                  <div class="mb-2"><strong>Data:</strong> {{ venda.data | date:'dd/MM/yyyy' }}</div>
                  <div class="mb-2"><strong>Total:</strong> {{ venda.total | abnt:'preco':2 }}</div>
                  <div>
                    <strong>Situação:</strong>
                    @let cor = corDaEtapa(venda);
                    <span class="status-badge ms-1" [style.background]="cor.fundo" [style.color]="cor.conteudo">{{ venda.situacao }}</span>
                  </div>
                </div>
              </div>
            }
          </div>

          @if (vendas.length === 10) {
            <small class="d-block text-muted mt-2">São exibidos apenas os 10 últimos registros.</small>
          }
        }
      </div>
    </mat-tab>

    <!-- ================= Produtos ================= -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="material-symbols-outlined tab-icon">inventory_2</mat-icon>
        <span class="tab-label-text">Produtos</span>
      </ng-template>

      <div class="ultimas-vendas-aba">
        @if (!possuiPermissaoVendas) {
          <app-empty-state icon="lock" title="Sem permissão para visualizar Processo de Venda"
            subtitle="Solicite ao administrador a permissão Visualizar do Processo de Venda.">
          </app-empty-state>
        } @else {
          <form (ngSubmit)="pesquisarProdutos()">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Pesquisar</mat-label>
              <input matInput type="text" [formControl]="pesquisaProdutos" placeholder="Descrição do produto" />
              <button mat-icon-button matSuffix type="submit" class="icon-mat-symbols-btn" aria-label="Pesquisar">
                <mat-icon class="material-symbols-outlined">search</mat-icon>
              </button>
            </mat-form-field>
          </form>

          @if (isCarregando.produtos) {
            <app-loading-box-default-list></app-loading-box-default-list>
          } @else if (produtos.length === 0) {
            @if (pesquisaAplicada) {
              <app-empty-state icon="search_off" title="Nenhum produto encontrado" subtitle="Revise a pesquisa.">
              </app-empty-state>
            } @else {
              <app-empty-state icon="inventory_2" title="Nenhum produto vendido"
                subtitle="Este cliente ainda não tem produtos em vendas, orçamentos ou notas fiscais.">
              </app-empty-state>
            }
          } @else {
            <div class="desktop-view">
              <div class="table-container">
                <table mat-table [dataSource]="produtosExibidos" matSort [matSortActive]="ordenacao.produtos.coluna"
                  [matSortDirection]="ordenacao.produtos.direcao"
                (matSortChange)="atualizarOrdenacao('produtos', $event)" class="w-100">
                  <ng-container matColumnDef="descricao">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
                    <td mat-cell *matCellDef="let produto" class="ultimas-vendas-descricao">{{ produto.descricao }}</td>
                  </ng-container>

                  <ng-container matColumnDef="valorUnitario">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Valor unitário</th>
                    <td mat-cell *matCellDef="let produto" class="text-end">{{ (produto.valorUnitario | abnt) || '—' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="quantidade">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-end">Quantidade</th>
                    <td mat-cell *matCellDef="let produto" class="text-end">{{ (produto.quantidade | abnt:'quantidade') || '—' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="data">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Data</th>
                    <td mat-cell *matCellDef="let produto">{{ produto.data | date:'dd/MM/yyyy' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="tipo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
                    <td mat-cell *matCellDef="let produto">{{ produto.tipo }}</td>
                  </ng-container>

                  <ng-container matColumnDef="numero">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Número</th>
                    <td mat-cell *matCellDef="let produto">
                      <ng-container *ngTemplateOutlet="tplNumeroProduto; context: { $implicit: produto }"></ng-container>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="colunasProdutos"></tr>
                  <tr mat-row *matRowDef="let row; columns: colunasProdutos"></tr>
                </table>
              </div>
            </div>

            <div class="mobile-view">
              @for (produto of produtosExibidos; track $index) {
                <div class="card-mobile mb-3">
                  <div class="card-header-mobile d-flex justify-content-between align-items-center gap-2">
                    <span class="ultimas-vendas-descricao">{{ produto.descricao }}</span>
                  </div>
                  <div class="card-body-mobile p-3">
                    <div class="mb-2"><strong>Valor unitário:</strong> {{ (produto.valorUnitario | abnt) || '—' }}</div>
                    <div class="mb-2"><strong>Quantidade:</strong> {{ (produto.quantidade | abnt:'quantidade') || '—' }}</div>
                    <div class="mb-2"><strong>Data:</strong> {{ produto.data | date:'dd/MM/yyyy' }}</div>
                    <div class="mb-2"><strong>Tipo:</strong> {{ produto.tipo }}</div>
                    <div>
                      <strong>Número:</strong>
                      <ng-container *ngTemplateOutlet="tplNumeroProduto; context: { $implicit: produto }"></ng-container>
                    </div>
                  </div>
                </div>
              }
            </div>

            @if (produtos.length === 10) {
              <small class="d-block text-muted mt-2">São exibidos apenas os 10 últimos registros.</small>
            }
          }
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>

<!-- CO-05: o número abre o documento e fecha o dialog. -->
<ng-template #tplNumeroNota let-nota>
  <button type="button" class="btn-link p-0 border-0 bg-transparent text-bold text-nowrap" [matTooltip]="'Abrir nota fiscal ' + nota.numero"
    [attr.aria-label]="'Abrir nota fiscal ' + nota.numero" (click)="abrirNotaFiscal(nota)">
    {{ nota.numero }}
  </button>
</ng-template>

<ng-template #tplNumeroVenda let-venda>
  <button type="button" class="btn-link p-0 border-0 bg-transparent text-bold text-nowrap"
    [matTooltip]="'Abrir pedido de venda ' + venda.numero"
    [attr.aria-label]="'Abrir pedido de venda ' + venda.numero" (click)="abrirVenda(venda.idVenda)">
    {{ venda.numero }}
  </button>
</ng-template>

<ng-template #tplNumeroProduto let-produto>
  <button type="button" class="btn-link p-0 border-0 bg-transparent text-bold text-nowrap"
    [matTooltip]="'Abrir ' + produto.tipo.toLowerCase() + ' ' + produto.numero"
    [attr.aria-label]="'Abrir ' + produto.tipo.toLowerCase() + ' ' + produto.numero" (click)="abrirDocumentoDoProduto(produto)">
    {{ produto.numero }}
  </button>
</ng-template>
